/* OVERAALL V6 Streetwear — swipes, photo galleries, intro. No third-party libraries. */
(function(){'use strict';
 const slider=document.querySelector('[data-ov5-slider]');
 function dragSwipe(el,onLeft,onRight){
   let start=null,blockedUntil=0;
   el.style.touchAction='pan-y';
   el.addEventListener('pointerdown',e=>{
     if(e.pointerType==='mouse'&&e.button!==0)return;
     start={x:e.clientX,y:e.clientY,t:Date.now()};
   },{passive:true});
   el.addEventListener('pointerup',e=>{
     if(!start)return;
     const dx=e.clientX-start.x,dy=e.clientY-start.y;
     if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy)*1.25){
       blockedUntil=Date.now()+700;
       if(dx<0)onLeft();else onRight();
     }
     start=null;
   },{passive:true});
   el.addEventListener('pointercancel',()=>{start=null;},{passive:true});
   el.addEventListener('click',e=>{
     if(Date.now()<blockedUntil){e.preventDefault();e.stopPropagation();}
   },true);
   el.addEventListener('keydown',e=>{
     if(e.key==='ArrowRight'){e.preventDefault();onLeft();}
     if(e.key==='ArrowLeft'){e.preventDefault();onRight();}
   });
 }
 if(slider){
  const slides=[...slider.querySelectorAll('[data-ov5-slide]')],names=[...slider.querySelectorAll('[data-ov5-product-link]')],count=slider.querySelector('[data-ov5-count]');let active=0;
  function show(next){
   if(!slides.length)return;
   active=(next+slides.length)%slides.length;
   slides.forEach((el,i)=>{
     const selected=i===active;
     el.classList.toggle('is-active',selected);
     el.setAttribute('aria-hidden',String(!selected));
     el.inert=!selected;
     el.querySelectorAll('a').forEach(a=>a.tabIndex=selected?0:-1);
   });
   names.forEach((a,i)=>a.hidden=i!==active);
   if(count)count.textContent=String(active+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
  }
  slider.querySelector('[data-ov5-prev]')?.addEventListener('click',()=>show(active-1));
  slider.querySelector('[data-ov5-next]')?.addEventListener('click',()=>show(active+1));
  const zone=slider.querySelector('[data-ov6-swipe-zone]');
  if(zone&&slides.length>1)dragSwipe(zone,()=>show(active+1),()=>show(active-1));
  show(0);
 }
 document.querySelectorAll('[data-ov6-gallery]').forEach(gallery=>{
  const photos=[...gallery.querySelectorAll('.ov6-card-photo')];
  const count=gallery.querySelector('[data-ov6-gallery-count]'),dots=[...gallery.querySelectorAll('.ov6-card-dot')];
  if(!photos.length)return;
  let index=0;
  function show(i){
    index=(i+photos.length)%photos.length;
    photos.forEach((p,k)=>{p.classList.toggle('is-current',k===index);p.setAttribute('aria-hidden',String(k!==index));});
    dots.forEach((d,k)=>d.classList.toggle('is-current',k===index));
    if(count)count.textContent=String(index+1).padStart(2,'0')+' / '+String(photos.length).padStart(2,'0');
  }
  if(photos.length>1)dragSwipe(gallery,()=>show(index+1),()=>show(index-1));
  const hoverMedia = window.matchMedia('(hover:hover) and (pointer:fine)');
  if(photos.length>1 && hoverMedia.matches){
    gallery.addEventListener('mouseenter',()=>show(1));
    gallery.addEventListener('mouseleave',()=>show(0));
    gallery.addEventListener('focusin',()=>show(1));
    gallery.addEventListener('focusout',()=>show(0));
  }
  show(0);
 });
 const intro=document.getElementById('ov5-intro');
 if(intro){
  let seen=false;
  try{seen=sessionStorage.getItem('ov6-intro-seen')==='yes';}catch(_){ }
  const reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  if(seen||reduce||window.Shopify?.designMode){intro.remove();return;}
  intro.setAttribute('aria-hidden','false');
  let doneOnce=false;
  const done=()=>{
    if(doneOnce)return;
    doneOnce=true;intro.classList.add('is-done');intro.setAttribute('aria-hidden','true');
    try{sessionStorage.setItem('ov6-intro-seen','yes');}catch(_){ }
    setTimeout(()=>intro.remove(),650);
  };
  const timer=setTimeout(done,1450);
  intro.querySelector('#ov5-intro-skip')?.addEventListener('click',()=>{clearTimeout(timer);done();});
 }
})();
